/**
 * http://usejsdoc.org/
 */

import React, { Component } from 'react';

import { connect } from 'react-redux'
import { Control, LocalForm } from 'react-redux-form';
import Select from 'react-select';
import loadsStore from '../../../stores/loads-store';
import jumpersStore from '../../../stores/jumpers-store';

import ReactDOM from 'react-dom';
import LoadUpdateModal from '../modals/loadModal'

class EditableRotationOrder extends Component {

    constructor(props) {
        super(props);
        this.handelConfirmSubmit = this.handelConfirmSubmit.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
        this.state = {
            isModalOpen: false,
            orderNumber: 0,
            type: '',
            warningPopUp: false
        };

        this.timerId = null;
        this.valRef = null;
        this.inputValue = '';
    }

    componentDidMount = () => {
        if (this.valRef !== null)
            this.valRef.focus();
    }

    componentDidUpdate = () => {
        if (this.valRef !== null)
            this.valRef.focus();
    }

    handleChange = (selectedOption, loadNum, jumpId, type, label) => {
        this.setState({ editMode: !this.state.editMode });
        var today = new Date();
        var isWeekend = (today.getDay() % 6 === 0);

        if (selectedOption.value !== undefined) {
            if (type === "tandem") {
                var tandemJump = this.props.tandemJump;

                if (this.state.isCompleted) {
                    if (label === "I") {
                        var jumpPostBody = {
                            instructorId: selectedOption.value._id,
                            studentId: this.props.tandemJump.student._id,
                            videographerId: this.props.tandemJump.videographer._id,
                            Timer: this.props.tandemJump.Timer,
                            videoTimer: this.props.tandemJump.videoTimer
                        }
                    }
                    else if (label === "V") {
                        var jumpPostBody = {
                            videographerId: selectedOption.value._id,
                            instructorId: this.props.tandemJump.instructor._id,
                            studentId: this.props.tandemJump.student._id,
                            Timer: this.props.tandemJump.Timer,
                            videoTimer: this.props.tandemJump.videoTimer
                        }
                    }
                    if (this.props.isToday) {
                        jumpPostBody.isToday = true
                    }
                    var jumpId = this.props.tandemJump.jumpId;
                    var loadId = this.props.loadId;
                    jumpPostBody.isUltra = this.props.isUltra;
                    jumpPostBody.isWeekend = isWeekend;
                    jumpPostBody.isTimerUpdate = false;
                    this.props.updateCompleteTandemJump(loadId, jumpId, jumpPostBody);
                }
                else {
                    if (label === "I") {
                        var jumpPostBody = { instructorId: selectedOption.value._id }
                    }
                    else if (label === "V") {
                        var jumpPostBody = { videographerId: selectedOption.value._id }
                    }
                    loadsStore.updateTandemJump(loadNum, jumpId, jumpPostBody);
                }
            }
            else if (type === "tandemUltra") {
                var tandemJump = this.props.tandemJump;
                if (this.state.isCompleted) {
                    if (label === "I") {
                        var jumpPostBody = {
                            instructorId: selectedOption.value._id,
                            studentId: this.props.tandemJump.student._id,
                            videographerId: this.props.tandemJump.videographer._id,
                            Timer: this.props.tandemJump.Timer,
                            videoTimer: this.props.tandemJump.videoTimer
                        }
                    }
                    else if (label === "V") {
                        var jumpPostBody = {
                            videographerId: selectedOption.value._id,
                            instructorId: this.props.tandemJump.instructor._id,
                            studentId: this.props.tandemJump.student._id,
                            Timer: this.props.tandemJump.Timer,
                            videoTimer: this.props.tandemJump.videoTimer
                        }
                    }
                    if (this.props.isToday) {
                        jumpPostBody.isToday = true
                    }

                    jumpPostBody.isTimerUpdate = false;

                    var jumpId = this.props.tandemJump.jumpId;

                    var loadId = this.props.loadId;

                    jumpPostBody.isUltra = this.props.isUltra;
                    jumpPostBody.isWeekend = isWeekend;
                    // console.log("updateCompleteTandemJump",jumpPostBody);
                    loadsStore.updateCompleteTandemJump(loadId, jumpId, jumpPostBody);
                }
                else {
                    if (label === "I") {
                        var jumpPostBody = { instructorId: selectedOption.value._id }
                    }
                    else if (label === "V") {
                        var jumpPostBody = { videographerId: selectedOption.value._id }
                    }
                    loadsStore.updateTandemJump(loadNum, jumpId, jumpPostBody);
                }
            }
            else if (type === "aff") {
                if (this.state.isCompleted) {
                    if (label === "I1") {
                        var jumpPostBody = {
                            mainInstructorId: selectedOption.value._id,
                            secondaryInstructorId: this.props.affJump.secondaryInstructor._id,
                            videographerId: this.props.affJump.videographer._id,
                            studentId: this.props.affJump.student._id,
                            Timer: this.props.affJump.Timer
                        }
                        if (this.props.affJump.secondaryInstructor) {
                            jumpPostBody.secondaryInstructorId = this.props.affJump.secondaryInstructor._id
                        }
                    }
                    else if (label === "I2") {
                        var jumpPostBody = {
                            secondaryInstructorId: selectedOption.value._id,
                            mainInstructorId: this.props.affJump.mainInstructor._id,
                            videographerId: this.props.affJump.videographer._id,
                            studentId: this.props.affJump.student._id,
                            Timer: this.props.affJump.Timer
                        }
                    }
                    else if (label === "V") {
                        var jumpPostBody = {
                            videographerId: selectedOption.value._id,
                            secondaryInstructorId: this.props.affJump.secondaryInstructor._id,
                            mainInstructorId: this.props.affJump.mainInstructor._id,
                            studentId: this.props.affJump.student._id,
                            Timer: this.props.affJump.Timer
                        }
                        if (this.props.affJump.secondaryInstructor) {
                            jumpPostBody.secondaryInstructorId = this.props.affJump.secondaryInstructor._id
                        }
                    }
                    else if (label === "S") {
                        var jumpPostBody = {
                            studentId: selectedOption.value._id,
                            videographerId: this.props.affJump.videographer._id,
                            secondaryInstructorId: selectedOption.value._id,
                            mainInstructorId: this.props.affJump.mainInstructor._id,
                            Timer: this.props.affJump.Timer
                        }
                        if (this.props.affJump.secondaryInstructor) {
                            jumpPostBody.secondaryInstructorId = this.props.affJump.secondaryInstructor._id
                        }
                    }
                    if (this.props.isToday) {
                        jumpPostBody.isToday = true
                    }
                    jumpPostBody.level = this.state.level;
                    jumpPostBody.isWeekend = isWeekend;
                    var cjumpId = this.props.affJump.jumpId;
                    var loadId = this.props.loadId;
                    this.props.updateCompletedAffJump(loadId, cjumpId, jumpPostBody);
                }
                else {
                    if (label === "I1") {
                        var jumpPostBody = { mainInstructorId: selectedOption.value._id }
                    }
                    else if (label === "I2") {
                        var jumpPostBody = { secondaryInstructorId: selectedOption.value._id }
                    }
                    else if (label === "V") {
                        var jumpPostBody = { videographerId: selectedOption.value._id }
                    }
                    else if (label === "S") {
                        var jumpPostBody = { studentId: selectedOption.value._id }
                    }
                    loadsStore.updateAffJump(loadNum, jumpId, jumpPostBody);
                }
            }
            else if (type === "coach") {

                if (this.state.isCompleted) {
                    if (label === "C") {
                        var jumpPostBody = { coachId: selectedOption.value._id };
                        if (this.props.isToday) {
                            jumpPostBody.isToday = true
                        }
                        jumpPostBody.TimerId = this.props.coachJump.Timer._id;
                        jumpPostBody.Timer = this.props.coachJump.Timer;
                        jumpPostBody.isWingsuit = this.props.isWingsuit;
                        var cjumpId = this.props.coachJump.jumpId;
                        var loadId = this.props.loadId;

                        this.props.updateCompletedCoachJump(loadId, cjumpId, jumpPostBody);
                    }
                    else if (label === "J") {
                        var jumpPostBody = { TimerId: selectedOption.value._id };
                        if (this.props.isToday) {
                            jumpPostBody.isToday = true
                        }
                        jumpPostBody.coach = this.props.coach._id;
                        jumpPostBody.Timer = this.props.Timer.Timer;
                        var cjumpId = this.props.coachJump.jumpId;
                        var loadId = this.props.loadId;
                        this.props.updateCompletedCoachJump(loadId, cjumpId, jumpPostBody);
                    }
                }
                else {
                    if (label === "C") {
                        var jumpPostBody = { coachId: selectedOption.value._id };
                        loadsStore.updateCoachJump(loadNum, jumpId, jumpPostBody);
                    }
                    else if (label === "J") {
                        var jumpPostBody = { TimerId: selectedOption.value._id };
                        loadsStore.updateCoachJump(loadNum, jumpId, jumpPostBody);
                    }
                }

            }
        }
    }

    cancelOrSubmit = () => {
        var ID = this.state.TimerId;
        var loadNum = this.state.loadNum;
        var jumpId = this.state.jumpId;
        var type = this.state.type;
        var label = this.state.label;

        var jumpPostBody = {};

        if (type === "tandem") {

            if (label === "I") {
                var jumpPostBody = { instructorId: ID }
            }
            else if (label === "V") {
                var jumpPostBody = { videographerId: ID }
            }
            loadsStore.updateTandemJump(loadNum, jumpId, jumpPostBody);
        }
        else if (type === "aff") {
            if (label === "I1") {
                var jumpPostBody = { mainInstructorId: ID }
            }
            else if (label === "I2") {
                var jumpPostBody = { secondaryInstructorId: ID }
            }
            else if (label === "V") {
                var jumpPostBody = { videographerId: ID }
            }
            loadsStore.updateAffJump(loadNum, jumpId, jumpPostBody);
        }
        else if (type === "coach") {
            if (label === "C") {
                var jumpPostBody = { coachId: ID };
                loadsStore.updateCoachJump(loadNum, jumpId, jumpPostBody);
            }
            else if (label === "J") {
                var jumpPostBody = { TimerId: ID };
                loadsStore.updateCoachJump(loadNum, jumpId, jumpPostBody);
            }
        }
    }

    checkForNegatives = (Timer) => {
        //console.log('check for negatives: ' + Timer);
        if (Timer != undefined) {
            let TimerCell = (Timer < 0) ?
                {
                    value: `($${Math.abs(Timer).toFixed(2)})`
                } :
                {
                    value: `$${Timer.toFixed(2)}`
                }

            if (Timer < 0) {
                return <span className="editableTimer" style={{ color: 'lightsalmon' }}> {TimerCell.value}</span>;
            }
            return <span className="editableTimer" style={{ color: '#00FF00' }}> {TimerCell.value}</span>;;
        }
        else {
            return '$0.00';
        }
    }

    wantsEidtable = (data) => {
        this.setState({
            editMode: data,
            isModalOpen: false
        }, () => {
            if (ReactDOM.findDOMNode(this).getBoundingClientRect().y > window.innerHeight / 2) {
                this.setState({ menuPlacement: "top" });
            }
            else {
                this.setState({ menuPlacement: "bottom" });
            }
        }
        )
    }

    changeOrderNumber = (e) => {
        e.preventDefault();
        if (!this.state.editMode) {
            this.setState({
                editMode: true
            })
        }

    }

    onBlur = () => {
        if (this.state.editMode && !this.props.isCompleted) {
            this.setState({
                editMode: false
            })
        }
    }

    handelConfirmSubmit() {
        this.setState({
            warningPopUp: !this.state.warningPopUp
        })
    }

    toggleModal() {
        this.setState({
            warningPopUp: !this.state.warningPopUp
        })
    }

    onBlur = () => {
        localStorage.setItem("disabledArrowButton", false)
        if (this.state.editMode && !this.props.isCompleted) {
            this.setState({
                editMode: false
            })
        }
    }


    handleInput(e, val) {
        alert(e);
    }

    handleSubmit(values) {
        this.setState({ editMode: !this.state.editMode });

        let payload = {
            orderNumber: Number(values.orderNumber),
            type: this.props.type
        };
        jumpersStore.updateStaffOrderNumber(this.props.jumperId, payload);

    }
    renderEditBtn = (type) => {
        return <button
            className="btn btn-info edit-btns"
            onClick={() => this.handleTimeChange(type)}
        >
            {type === "inc" ? '+' : '-'}
        </button>
    }
    handleOrderChange = (type) => {
        let { timeRemaining, loadNum } = this.props;
        let newTime = Number(timeRemaining);
        if (type === 'inc') {
            newTime = newTime + 1;
        }
        else if (timeRemaining > 0) {
            newTime = newTime - 1;
        }
        let payload = { timeRemaining: Number(newTime) }

    }

    render() {
        const { type, orderNumber } = this.props;
        const { isModalOpen, editMode } = this.state;
        return (
            <React.Fragment>

                {
                    !editMode ?
                        <span onClick={(e) => this.changeOrderNumber(e)}> - {orderNumber}</span>
                        :
                        <LocalForm
                            form="editOrderNumber"
                            style={{ width: '90px', display: 'inline' }}
                            model="editOrderNumber"
                            getDispatch={dispatch => this.formDispatch = dispatch}
                            onSubmit={(values) => this.handleSubmit(values)}
                            className={"cc"}
                        >
                            <span>
                                <Control.input
                                    name="orderNumber"
                                    model=".orderNumber"
                                    style={{ width: '40px', display: "inline-block" }}
                                    getRef={(node) => this.valRef = node}
                                    mapProps={{ onChange: (props) => props.onChange }}
                                    autoComplete="off"
                                    onBlur={this.onBlur}
                                />
                            </span>
                        </LocalForm>
                }




                <LoadUpdateModal
                    isOpen={isModalOpen}
                    onClick={this.wantsEidtable}
                />
            </React.Fragment>
            // <React.Fragment>
            //     {
            //         !editMode ?
            //             // <button className="btn lightBlueButton Timer-name" onClick={(e) => { e.preventDefault(); this.changeTimer(this.props.isCompleted); }} type="submit" disabled={this.props.disabled}>
            //             <span
            //                 onClick={(e) => { e.preventDefault(); this.changeTimer(isCompleted); }}
            //                 disabled={disabled}>
            //                 {timeRemaining}
            //             </span>
            //             //</button>
            //             :
            //             // <button className="btn lightBlueButton Timer-name" disabled={this.props.disabled}>
            //             <LocalForm
            //                 form="editTimers"
            //                 style={{ display: 'inline' }}
            //                 model="editTimers"
            //                 getDispatch={dispatch => this.formDispatch = dispatch}
            //                 onSubmit={(values) => this.handleSubmit(values, loadNum)}
            //             >
            //                 <span>
            //                     <Control.input
            //                         name="timer"
            //                         model=".timer"
            //                         style={{ width: '40px', display: "inline-block" }}
            //                         getRef={(node) => this.valRef = node}
            //                         mapProps={{ onChange: (props) => props.onChange }} defaultValue={Timer}
            //                         autoComplete="off"
            //                         onBlur={this.onBlur}
            //                     />
            //                 </span>
            //             </LocalForm>
            //     }
            //
            // </React.Fragment>
        );
    }
}

const mstp = state => {
    return {
        state
    }
}
const mdtp = dispatch => {
    return {
        updateCompletedAffJump: (loadId, cjumpId, jumpPostBody) => dispatch(loadsStore.updateCompletedAffJump(loadId, cjumpId, jumpPostBody)),
        updateCompleteTandemJump: (loadId, cjumpId, jumpPostBody) => dispatch(loadsStore.updateCompleteTandemJump(loadId, cjumpId, jumpPostBody)),
        updateCompletedCoachJump: (loadId, cjumpId, jumpPostBody) => dispatch(loadsStore.updateCompletedCoachJump(loadId, cjumpId, jumpPostBody)),
        addCompletedJumpers: (loadId, cjumpId, jumpPostBody) => dispatch(loadsStore.addCompletedJumpers(loadId, cjumpId, jumpPostBody)),
    }
}

export default connect(mstp, mdtp)(EditableRotationOrder)
